import { Cloud } from "lucide-react";
import { useTranslation } from "react-i18next";
import styles from "./UserAuthButton.module.css";

export interface UserAuthButtonProps {
  isAuthenticated: boolean;
  fullName?: string | null;
  email?: string | null;
  avatarUrl?: string | null;
  onClick: () => void;
}

export const UserAuthButton = ({
  isAuthenticated,
  fullName,
  email,
  avatarUrl,
  onClick,
}: UserAuthButtonProps) => {
  const { t } = useTranslation();

  const initial = (fullName || email)?.charAt(0).toUpperCase();
  const title = isAuthenticated
    ? t("header.signedInAs", { name: fullName || email })
    : t("header.syncAcrossDevices");

  return (
    <button
      onClick={onClick}
      className={`${styles["auth-button"]} ${isAuthenticated ? styles["auth-button--authenticated"] : ""}`}
      title={title}
    >
      {isAuthenticated ? (
        <>
          {avatarUrl ? (
            <img
              src={avatarUrl}
              alt={fullName || email || "User"}
              className={styles["auth-button__avatar"]}
            />
          ) : (
            <span className={styles["auth-button__initial"]}>
              {initial}
            </span>
          )}
        </>
      ) : (
        <>
          <Cloud size={18} />
          <span>{t("header.signIn")}</span>
        </>
      )}
    </button>
  );
};

